var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.initiated ? _c(_vm.SkinComponent, _vm._g({
    tag: "component",
    attrs: {
      "code": _vm.code
    },
    on: {
      "prev": function ($event) {
        return _vm.$emit('prev');
      }
    },
    model: {
      value: _vm.form,
      callback: function ($$v) {
        _vm.form = $$v;
      },
      expression: "form"
    }
  }, {
    save: _vm.save
  })) : _vm._e();

}
var staticRenderFns = []

export { render, staticRenderFns }